<h2 [ngClass]="{'black-text': isTextBlack}">{{text}}</h2>